function isMatchPointValid(placeholder, key) {
    const pattern = `^${placeholder.replace(/:\w+/g, '\\w+')}$`;
    const regexp = new RegExp(pattern);
    return regexp.test(key);
}
function isNamedPlaceHolder(key) {
    if (key.includes(':')) {
        return true;
    }
    return false;
}

export { isMatchPointValid, isNamedPlaceHolder };
//# sourceMappingURL=match-point-regex.js.map
